function DeviceAssignment(aDeviceId, aEnrolleeId) {
    "use strict";

    this.__type = 'DeviceAssignment:www.veritracks.com';
    this.Id = aDeviceId;
    this.Version = 0;

    this.EndDate = new Date('12/31/9999');
    this.EnrolleeId = aEnrolleeId;
    this.ReasonForChange = '';
    this.ChargerReturnStatus = '';
    this.StartDate = new Date();
    this.AudibleToneFlag = 0;
    this.AlcoholDeviceId = -1;
}
if (typeof exports !== 'undefined') {
    module.exports = DeviceAssignment;
}